import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/app/common/common-components/ui/AlertDialog";
import { MessageTemplate } from "@/app/models/MessageTemplateModel";

interface DeleteTemplateConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  template: MessageTemplate | undefined;
  onConfirm: () => void;
  isDeleting: boolean;
}

const DeleteTemplateConfirmationDialog: React.FC<DeleteTemplateConfirmationDialogProps> = ({ isOpen, onClose, template, onConfirm, isDeleting }) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Template</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete the template "{template?.templateName}"? This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isDeleting}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={isDeleting} className="hover:tw-bg-destructive/90 tw-bg-destructive tw-text-destructive-foreground">
            {isDeleting ? "Deleting..." : "Delete"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteTemplateConfirmationDialog;
